"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var globalTypes_1 = require("src/schemaTypes/globalTypes");
var findActiveBlackout = function (bookCardFragment, currentUser) {
    var _a, _b, _c;
    if (currentUser.userType !== globalTypes_1.UserType.student) {
        return null;
    }
    var bookAccessDetails = ((_a = currentUser) === null || _a === void 0 ? void 0 : _a.bookShelf) && ((_b = currentUser) === null || _b === void 0 ? void 0 : _b.bookShelf.find(function (accesssDetails) { return accesssDetails.bookId === bookCardFragment.id; }));
    if (!bookAccessDetails) {
        return null;
    }
    var epochTime = new Date().getTime() / 1000;
    var blackoutMatches = (_c = bookCardFragment.blackouts) === null || _c === void 0 ? void 0 : _c.filter(function (blackout) {
        return (blackout.startDate || Number.MAX_VALUE) < epochTime &&
            epochTime < (blackout.endDate || Number.MIN_VALUE) &&
            bookAccessDetails.createdAt <
                (blackout.bookAccessCuttoff || Number.MIN_VALUE);
    });
    if (!blackoutMatches || blackoutMatches.length === 0) {
        return null;
    }
    return blackoutMatches[0];
};
exports.default = findActiveBlackout;
